import { Helmet } from 'react-helmet'
import { APP } from '@/common/strings'
import { H1 } from '@/common/ui'
import BundleCards from './bundles'
import { INVEST_COPY } from '@/locales/en'
import { TrendingEtfs } from './trendingEtfs'
import { ORDER_FROM } from '@/common/context/orderSourceValues'

export function Invest() {
    return (
        <div>
            <Helmet>
                <title>
                    {INVEST_COPY.title} | {APP.title}
                </title>
            </Helmet>
            <div className="self-stretch inline-flex flex-col justify-start items-start gap-8">
                <H1 className="justify-start mb-0 font-normal">{INVEST_COPY.title}</H1>

                <div className="mb-10 grid grid-cols-1 gap-12">
                    <BundleCards />
                    <TrendingEtfs orderFrom={ORDER_FROM.INVEST} />
                </div>
            </div>
        </div>
    )
}
